import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Office as OfficeType } from '../../lawFirm.types';
import { OfficeList } from '../../../entity/entity-lists/OfficeList';
import { AllOfficesModal } from '../../../modals/entity-lists/AllOfficesModal';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import { withUser } from '../../../user/UserContext';
import { RestrictedModal } from '../../../components/modal/components/modal-restricted/RestrictedModal';
import { withModal, WithModalProps } from '../../../components/modal/withModal';
import { UserContextType } from '../../../user/user.types';
import {
  EntityBlock,
  EntityBlockTitle,
} from '../../../entity/components/EntityBlockComponents';
import { SeeMore } from '../../../components/see-more/SeeMore';

type Props = {
  offices: Array<OfficeType>;
  LawFirmName: string;
  lawOfficeIdGroup: string;
} & UserContextType &
  WithModalProps;

export class RawOffices extends React.Component<Props> {
  id = 'law-firm-offices';

  limit = 5;

  componentDidMount() {
    window.dispatchEvent(
      new CustomEvent('createNav', {
        detail: this.id,
      }),
    );
  }

  handleSeeMoreClick = () => {
    const {
      lawOfficeIdGroup,
      accessPremium,
      openModal,
      offices,
      LawFirmName,
    } = this.props;
    if (accessPremium) {
      openModal(modalProps => (
        <AllOfficesModal
          offices={offices}
          lawFirmName={LawFirmName}
          {...modalProps}
        />
      ));
    } else {
      openModal(modalProps => (
        <RestrictedModal source="law_firm_see_more_offices" {...modalProps} />
      ));
    }
    doctrineAnalytics('LawFirm SeeMoreOffices', {
      law_office_id_group: lawOfficeIdGroup,
    });
  };

  render() {
    const { LawFirmName, offices } = this.props;
    const officeShortList = offices.slice(0, this.limit);
    const hasMore = offices.length > this.limit;
    return (
      <>
        <h2 id={this.id} className="entity__section-title">
          <FormattedMessage
            id="law-firm/page/firm/Offices.tsx/1"
            values={{ LawFirmName }}
          />
        </h2>
        <EntityBlock>
          <EntityBlockTitle>
            <FormattedMessage id="law-firm/page/firm/Offices.tsx/2" />
          </EntityBlockTitle>
          <div className="entity__block__separator" />
          <OfficeList offices={officeShortList} source="law_firm_offices" />
          {hasMore && (
            <SeeMore onClick={this.handleSeeMoreClick}>
              {`Voir plus (${offices.length})`}
            </SeeMore>
          )}
        </EntityBlock>
      </>
    );
  }
}

export const Offices = withUser(withModal(RawOffices));
